import React, { useState } from 'react';
import { t } from 'translates';
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap';
import PerfectScrollbar from 'react-perfect-scrollbar'
import classNames from "classnames";

function Participants(props) {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = (e) => {
    setDropdownOpen(!dropdownOpen)
  };

  return (
    <div className='product-reservation__participants'>
      <h4>{t('Number of participants', DT_RESERVATION)}</h4>
      <Dropdown
        className="sessions-new-filter__select"
        isOpen={dropdownOpen}
        toggle={toggle}
      >
        <DropdownToggle
          tag="button"
          data-toggle="dropdown"
          className="sessions-new-filter__select-trigger"
          aria-expanded={dropdownOpen}
          disabled={+props.maxPersons == 1 || props.staffUser}
        >
          {props.persons > 1 ? (
            <p>
              {props.persons} {t('participants', DT_RESERVATION)}
            </p>

          ):(
            <p>
              {props.persons} {t('participant', DT_RESERVATION)}
            </p>
          )}
        </DropdownToggle>
        <DropdownMenu className="sessions-new-filter__select-dropdown">
          <PerfectScrollbar options={{wheelPropagation: false}}  className="sessions-new-filter__select-item-wrapper">
            {new Array(props.maxPersons).fill(1).map((_, i) => (
                <button
                  className={classNames("sessions-new-filter__select-item", {
                    'is-active': props.persons == i+1
                  })}
                  key={Math.random()}
                  onClick={() => {props.setPersons(i+1); toggle();}}
                >

                {i+1 > 1 ? (
                  <p>
                    {i+1} {t('participants', DT_RESERVATION)}
                  </p>

                ):(
                  <p>
                    {i+1} {t('participant', DT_RESERVATION)}
                  </p>
                )}
                </button>
            ))}
          </PerfectScrollbar>
        </DropdownMenu>
      </Dropdown>
    </div>

  );
}

export default  Participants;
